import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
export const TypeaheadFormControlWrapper = styled.div.withConfig({
  displayName: "Formsstyles__TypeaheadFormControlWrapper",
  componentId: "zwd344-0"
})(["min-height:6.8rem;label{font-size:16px;font-weight:400;}@media ", "{min-height:8.25rem;}"], devices.desktop);
export const SignupDataInputIcon = styled.div.withConfig({
  displayName: "Formsstyles__SignupDataInputIcon",
  componentId: "zwd344-1"
})(["position:absolute;bottom:0;top:0;right:2px;display:flex;align-items:center;"]);